<script>
import { BFormGroup, BFormInput, BModal } from "bootstrap-vue-next";

export default {
  name: "SeatModal",
  components: {
    BFormGroup,
    BFormInput,
    BModal,
  },
  props: {
    modelValue: { type: Boolean, default: false },
    label: { type: String, default: "" },
    seats: { type: Number, default: 0 },
  },
  emits: ["update:modelValue", "apply", "hidden"],
  data() {
    return {
      currentSeats: this.seats,
    };
  },
  watch: {
    modelValue(shown) {
      if (shown) {
        this.currentSeats = this.seats;
      }
    },
  },
  methods: {
    apply() {
      this.$emit("apply", Math.max(parseInt(this.currentSeats, 10) || 0, 0));
    },
  },
};
</script>

<template>
  <BModal
    :model-value="modelValue"
    title="Seats"
    ok-title="Apply"
    body-class="text-start"
    @update:model-value="$emit('update:modelValue', $event)"
    @ok="apply"
    @hidden="$emit('hidden')"
  >
    <BFormGroup :label="label" label-for="seat-count">
      <BFormInput
        id="seat-count"
        v-model="currentSeats"
        type="number"
        min="0"
      />
    </BFormGroup>
  </BModal>
</template>
